import {
  createAsyncThunk,
  createSlice,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import history from "@history";
import { ApiUserAdmin, endpoints_userAdmin } from "src/app/api/userAdminApi";

const api = new ApiUserAdmin();

export const getUsers = createAsyncThunk(
  "userApp/admin/getUsers",
  async (params, { getState }) => {
    const data = await api.get(endpoints_userAdmin.ADMINUSERS);
    return { data };
  }
);

export const getUser = createAsyncThunk(
  "userApp/admin/getUser",
  async (id, { dispatch, getState }) => {
    try {
      const data = await api.get(endpoints_userAdmin.ADMINUSERS, id);
      return { data };
    } catch (error) {
      history.push({ pathname: `/userAdmin` });

      return null;
    }
  }
);

export const addUser = createAsyncThunk(
  "userApp/admin/addUser",
  async (user, { dispatch, getState }) => {
    user.active = true;
    const data = await api.post(endpoints_userAdmin.ADMINUSERS, user);
    return { data };
  }
);

export const updateUser = createAsyncThunk(
  "userApp/admin/updateUser",
  async (user, { dispatch, getState }) => {
    try {
      const data = await api.put(endpoints_userAdmin.ADMINUSERS, user.id, user);
      return { data };
    } catch (error) {
      return error;
    }
  }
);

export const removeUser = createAsyncThunk(
  "userApp/admin/removeUser",
  async (user, { dispatch, getState }) => {
    try {
      const deletedUser = {
        id: user.id,
        name: user.name,
        password: user.password,
        email: user.email,
        active: false,
      };
      const data = await api.put(
        endpoints_userAdmin.ADMINUSERS,
        user.id,
        deletedUser
      );
      return data.id;
    } catch (error) {
      return error;
    }
  }
);

const userAdapter = createEntityAdapter();

const userSlice = createSlice({
  name: "userApp/admin",
  initialState: userAdapter.getInitialState({
    selectedUserId: null,
  }),
  reducers: {
    clearSelectedUser: (state) => {
      state.selectedUserId = null;
    },
    setSelectedUser: (state, action) => {
      state.selectedUserId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action) => {
        userAdapter.setAll(state, action.payload.data);
      })
      .addCase(addUser.fulfilled, (state, action) => {
        userAdapter.addOne(state, action.payload.data);
      })
      .addCase(getUser.fulfilled, (state, action) => {
        userAdapter.upsertOne(state, action.payload.data);
      })
      .addCase(removeUser.fulfilled, (state, action) => {
        userAdapter.removeOne(state, action.payload.id);
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        userAdapter.upsertOne(state, action.payload.data);
      });
  },
});

export const { clearSelectedUser, setSelectedUser } = userSlice.actions;

// Selectores generados automáticamente
export const { selectAll: selectUser, selectById: selectUserById } =
  userAdapter.getSelectors((state) => state.userApp.admin);

export const selectSelectedUser = (state) => {
  const id = state.userApp.admin.selectedUserId;
  return id ? selectUserById(state, id) : null;
};

export default userSlice.reducer;
